import { render, staticRenderFns } from "./prizeSetting.vue?vue&type=template&id=49fd109f&scoped=true"
import script from "./prizeSetting.vue?vue&type=script&lang=js"
export * from "./prizeSetting.vue?vue&type=script&lang=js"
import style0 from "./prizeSetting.vue?vue&type=style&index=0&id=49fd109f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd109f",
  null
  
)

export default component.exports